import React, { ReactElement } from 'react';
import { ChildrenOnly } from '../../../../../../../common/types/ChildrenOnly';
import { TagView, Value } from './Tag.styles';

export interface Props extends ChildrenOnly {
  icon?: ReactElement;
}

export const Tag = ({ children, icon }: Props) => (
  <TagView>
    {icon}
    <Value>{children}</Value>
  </TagView>
);
